import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Modal,
  TextField,
  Typography
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useEffect, useState } from 'react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import MealsResult from '../MealsResult';
import AddMealModal from '../Modals/addMealsModal';
import EditMealModal from '../Modals/editMealsModal';

const DietPlanForm = ({
  errors,
  handleBlur,
  handleChange,
  handleSubmit,
  isSubmitting,
  touched,
  values,
  heading = '',
  handleCloseModal,
  setFieldValue,
  isFromUpdateTrainer
}) => {
  const [meals, setMeals] = useState([]);
  const [mealsModal, setMealsModal] = useState(false);
  const [editMealsModal, setEditmealsModal] = useState(false);
  const [editData, setEditData] = useState();
  const handleMealModal = () => {
    setMealsModal((prev) => !prev);
  };

  const hadleEditMealModal = () => {
    setEditmealsModal((prev) => !prev);
  };

  useEffect(() => {
    if (isFromUpdateTrainer && meals?.length < 1) {
      setMeals(values?.meals);
    }
  }, [isFromUpdateTrainer, values?.meals]);

  useEffect(() => {
    if (meals?.length > 0) {
      setFieldValue('meals', meals);
    }
  }, [meals]);

  const handleDelete = (item) => {
    setMeals(meals.filter((meal) => meal.id !== item.id));
  };

  const handleEdit = (item) => {
    hadleEditMealModal();
    const editItem = meals.filter((meal) => meal.id === item.id);
    setEditData(editItem[0]);
  };

  return (
    <>
      <Modal
        sx={{ overflow: 'scroll', padding: '1rem' }}
        open={mealsModal}
        onClose={handleMealModal}
      >
        <AddMealModal
          handleCloseModal={handleMealModal}
          setMeals={setMeals}
          meals={meals}
        />
      </Modal>
      <Modal
        sx={{ overflow: 'scroll', padding: '1rem' }}
        open={editMealsModal}
        onClose={hadleEditMealModal}
      >
        <EditMealModal
          handleCloseModal={hadleEditMealModal}
          editData={editData}
          setMeals={setMeals}
          meals={meals}
        />
      </Modal>
      <form onSubmit={handleSubmit}>
        <Box sx={{ mb: 3, display: 'flex', justifyContent: 'space-between' }}>
          <Typography color="textPrimary" variant="h2">
            {heading}
          </Typography>
          {handleCloseModal && (
            <CloseIcon sx={{ cursor: 'pointer' }} onClick={handleCloseModal} />
          )}
        </Box>

        <TextField
          error={Boolean(touched.name && errors.name)}
          fullWidth
          helperText={touched.name && errors.name}
          label="Name"
          margin="normal"
          name="name"
          onBlur={handleBlur}
          onChange={handleChange}
          type="text"
          value={values.name}
          variant="outlined"
        />
        <TextField
          error={Boolean(touched.diet && errors.diet)}
          fullWidth
          helperText={touched.diet && errors.diet}
          label="Diet"
          margin="normal"
          name="diet"
          onBlur={handleBlur}
          onChange={handleChange}
          type="text"
          value={values.diet}
          variant="outlined"
        />

        <Accordion style={{ background: '#f4f4f4' }}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1-content"
            id="panel1-header"
          >
            <p
              style={{
                fontFamily: 'Roboto'
              }}
            >
              MEAL LIST
            </p>
          </AccordionSummary>
          <AccordionDetails>
            <Box sx={{ mb: 3 }}>
              <div
                onClick={() => {
                  handleMealModal();
                }}
              >
                <Button color="primary" variant="outlined">
                  Add New Meal
                </Button>
              </div>
            </Box>

            <div>
              <MealsResult
                setMeals={setMeals}
                meals={meals}
                onEdit={handleEdit}
                onDelete={handleDelete}
              />
            </div>
          </AccordionDetails>
        </Accordion>

        {errors.meals ? (
          <p
            style={{
              color: 'red',
              fontFamily: 'Roboto',
              fontSize: '0.8rem',
              marginLeft: '15px',
              marginTop: '5px'
            }}
          >
            {errors.meals}
          </p>
        ) : (
          ''
        )}

        <TextField
          error={Boolean(touched.comments && errors.comments)}
          fullWidth
          helperText={touched.comments && errors.comments}
          label="Comments"
          margin="normal"
          name="comments"
          onBlur={handleBlur}
          onChange={handleChange}
          type="text"
          value={values.comments}
          variant="outlined"
        />

        <TextField
          error={Boolean(touched.prescribed_by && errors.prescribed_by)}
          fullWidth
          helperText={touched.prescribed_by && errors.prescribed_by}
          label="Prescribed By"
          margin="normal"
          name="prescribed_by"
          onBlur={handleBlur}
          onChange={handleChange}
          type="text"
          value={values.prescribed_by}
          variant="outlined"
        />

        <Box sx={{ py: 2 }}>
          <Button
            color="primary"
            disabled={isSubmitting}
            fullWidth
            size="large"
            type="submit"
            variant="contained"
          >
            {heading}
          </Button>
        </Box>
      </form>
    </>
  );
};

export default DietPlanForm;
